module.exports = __webpack_public_path__ + "8c7b3733fe19568dae912c19c33dcc7f.pdf";